import { useState } from 'react'

import { Divider, styled } from '@mui/material';
import Recent_3_Year from 'src/components/adminAchive/Recent_3_Year';
import Stage_By_Rate from 'src/components/adminAchive/Stage_By_Rate';
import Legion_Expose from 'src/components/adminAchive/Legion_Expose';
import Promoter_Analysis from 'src/components/adminAchive/Promoter_Analysis';
import School_Analysis from 'src/components/adminAchive/School_Analysis';
import Team_Analysis from 'src/components/adminAchive/Team_Analysis';
import { useStorageStore } from 'src/stores/StorageStore';

const PageWrapper = styled('div')(({theme})=>({
  margin : '30px 30px',
  backgroundColor:'white',
  borderRadius:'10px',
  height: 'calc(100vh - 126px)', // 필요시 조정
  overflow: 'hidden', // 전체적으로 overflow 방지
}))

const StatusWrapper = styled('div')(({theme})=>({
  display: 'flex',
  justifyContent:'space-around',
  alignItems:'center',

  width:'100%'
}))

const StatusContainer = styled('button',{
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status: boolean }>(({ theme, status })=>({
  all:'unset',
  display:'flex',
  justifyContent:'center',
  alignItems:'center',
  gap:'10px',
  
  width:'100%',
  padding:'24px',
  position:'relative',
  cursor:'pointer',
  color: status ? '#30515B' : '#AAAAAA',
  fontSize:'18px',
  fontWeight:'bold',
  whiteSpace:'nowrap'
}))

const Dividersx ={
  width: '90%', 
  height: '2px', 
  backgroundColor: '#30515B', 
  bottom:0, 
  position:'absolute'
}

type statusType = '최근 3개년 성과' | '단계별 전환률' | '지역별 노출도' | '홍보관별 성과 분석' | '학교별 성과 분석' | '팀별 성과 분석'

const AdAchivePage = () => {
  const [status, setStatus] = useState<statusType>('단계별 전환률')
  const storage = useStorageStore()
  const [userInfo] = useState(storage.getItem('user').data)

  return (
    <PageWrapper>
      <StatusWrapper>
        <StatusContainer status={status === '단계별 전환률'} onClick={()=>setStatus('단계별 전환률')}>단계별 전환률{status === '단계별 전환률' && <Divider sx={Dividersx}/>}</StatusContainer>
        <StatusContainer status={status === '지역별 노출도'} onClick={()=>setStatus('지역별 노출도')}>지역별 노출도{status === '지역별 노출도' && <Divider sx={Dividersx}/>}</StatusContainer>
        {userInfo?.user_type === 'admin' &&
        <StatusContainer status={status === '팀별 성과 분석'} onClick={()=>setStatus('팀별 성과 분석')}>팀별 성과 분석{status === '팀별 성과 분석' && <Divider sx={Dividersx}/>}</StatusContainer>
        }
        <StatusContainer status={status === '홍보관별 성과 분석'} onClick={()=>setStatus('홍보관별 성과 분석')}>홍보관별 성과 분석{status === '홍보관별 성과 분석' && <Divider sx={Dividersx}/>}</StatusContainer>
        <StatusContainer status={status === '학교별 성과 분석'} onClick={()=>setStatus('학교별 성과 분석')}>학교별 성과 분석{status === '학교별 성과 분석' && <Divider sx={Dividersx}/>}</StatusContainer>
        <StatusContainer status={status === '최근 3개년 성과'} onClick={()=>setStatus('최근 3개년 성과')}>최근 3개년 성과{status === '최근 3개년 성과' && <Divider sx={Dividersx}/>}</StatusContainer>
      </StatusWrapper>
      {status === '최근 3개년 성과' && <Recent_3_Year/>}
      {status === '단계별 전환률' && <Stage_By_Rate/>}
      {status === '지역별 노출도' && <Legion_Expose/>}
      {status === '팀별 성과 분석' && <Team_Analysis/>}
      {status === '홍보관별 성과 분석' && <Promoter_Analysis/>}
      {status === '학교별 성과 분석' && <School_Analysis/>}
    </PageWrapper>
  )
}

export default AdAchivePage